import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import { ACCESS_COLOR, BORDER_COLOR } from '~/src/feature/toyono/constants';

const Container = styled.div<{ theme: Theme }>`
  max-width: 1200px;
  margin: ${({ theme }) => theme.spacing(0, 'auto', 6)};
  width: 100%;
  text-align: left;
`;

const Description = styled.div`
  background: ${ACCESS_COLOR};
  padding: ${({ theme }) => theme.spacing(1, 3)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
    padding: ${({ theme }) => theme.spacing(3)}px;
  }
`;

const DescriptionText = styled.div<{ theme: Theme }>`
  text-align: left;
  padding: ${({ theme }) => theme.spacing(2, 0)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 50%;
  }
`;

const RightDescriptionText = styled(DescriptionText)`
  border-top: ${BORDER_COLOR} dotted 2px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    border-top: none;
    border-left: ${BORDER_COLOR} dotted 2px;
    padding-left: ${({ theme }) => theme.spacing(5)}px;
  }
`;

const DescriptionTitle = styled.div<{ theme: Theme }>`
  padding: ${({ theme }) => theme.spacing(0, 0, 2, 0)};
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: ${({ theme }) => theme.spacing(0, 0, 4, 6)};
    font-size: ${({ theme }) => theme.typography.pxToRem(22)};
  }
`;

const DirectionTitle = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.spacing(1)}px;
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: ${({ theme }) => theme.spacing(3)}px;
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  }
`;

const Img = styled.img<{ theme: Theme }>`
  width: 45px;
  padding-right: ${({ theme }) => theme.spacing(1)}px;
`;

interface Props {
  icon: string;
  title: string;
  leftText: React.ReactNode;
  rightText: React.ReactNode;
}

const AccessDirection: VFC<Props> = ({
  icon,
  title,
  leftText,
  rightText,
}: Props) => {
  const theme = useTheme();

  return (
    <Container theme={theme}>
      <DescriptionTitle theme={theme}>
        <Img src={icon} theme={theme} alt="" />
        {title}
      </DescriptionTitle>
      <Description theme={theme}>
        <DescriptionText theme={theme}>
          <DirectionTitle theme={theme}>
            ・妙見口（妙見山・初谷渓谷）方面へ
          </DirectionTitle>
          {leftText}
        </DescriptionText>
        <RightDescriptionText theme={theme}>
          <DirectionTitle theme={theme}>・牧・余野方面へ</DirectionTitle>
          {rightText}
        </RightDescriptionText>
      </Description>
    </Container>
  );
};

export default AccessDirection;
